import React from 'react';
import { Button, FormControl, Grid, InputLabel, Select, TextField } from '@mui/material';
import CpfCnpj from '../../../../components/common/CpfCnpj';
import SuggestContributors from '../../../../components/common/SuggestContributors';
import ClientsDropDown from '../../../../components/common/ClientsDropdown';
import AgentsDropDown from '../../../../components/common/AgentsDropdown';
import ORBApi from '../../../../services/ORBApi';
import Loading from '../../../../components/common/Loading';
import { toast } from 'react-toastify';

const EditUserPanel = ({ user, onUpdate }) => {

    const [isRunning, setIsRunning] = React.useState(false);
    const [userInfo, setUserInfo] = React.useState({
        id: user?.id || '',
        name: user?.name || '',
        email: user?.email || '',
        document: user?.document || '',
        type: user?.user_type || 'ARTIST',
        contributor_name: user?.contributor || '',
        contributor_id: user?.contributor_id || '',
        client_id: user?.client_id || '',
        agent_id: user?.agent_id || '',
        language_preference: user?.language_preference || 'PT'
    });
    const [formErrors, setFormErrors] = React.useState(
        { name: false, email: false, document: false, type: false, contributor: false, client: false, agent: false }
    );

    const validateForm = () => {
        let triggered = false;
        let newErrors = { name: false, email: false, document: false, type: false, contributor: false, client: false, agent: false };

        if (userInfo.name.length < 2) {
            newErrors.name = true;
            triggered = true;
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!userInfo.email || !emailPattern.test(userInfo.email)) {
            newErrors.email = true;
            triggered = true;
        }
        let docSize = (userInfo.document || '').replace(/\D/g, '').length;
        if (!userInfo.document || (docSize !== 11 && docSize !== 14)) {
            newErrors.document = true;
            triggered = true;
        }
        if (userInfo.type === "ARTIST") {
            if (!userInfo.contributor_id) {
                newErrors.contributor = true;
                triggered = true;
            }
        } else if (userInfo.type === "CLIENT") {
            if (!userInfo.client_id) {
                newErrors.client = true;
                triggered = true;
            }
        } else if (userInfo.type === "AGENT") {
            if (!userInfo.agent_id) {
                newErrors.agent = true;
                triggered = true;
            }
        }

        setFormErrors(newErrors);
        return !triggered;
    };

    const updateUser = () => {
        if (!validateForm())
            return;

        setIsRunning(true);
        ORBApi.updateUser(
            userInfo.id, userInfo.name, userInfo.email, userInfo.document, userInfo.type,
            userInfo.contributor_id, userInfo.client_id, userInfo.agent_id, userInfo.language_preference
        )
        .then(() => {
            toast.success('Usuário atualizado com sucesso!');
            if (onUpdate) onUpdate(userInfo);
        })
        .catch((ex) => {
            let errorMessage = 'Houve um problema na atualização do usuário.';
            if (ex?.response?.data?.description) {
                errorMessage = ex.response.data.description;
            } else if (ex?.response?.data?.message) {
                errorMessage = ex.response.data.message;
            } else if (ex?.message) {
                errorMessage += ` ${ex.message}`;
            }
            toast.error(errorMessage);
            console.error('Error updating user:', ex);
        })
        .finally(() => {
            setIsRunning(false);
        });
    };

    return (
        <>
        <h4 className='title'>Editar usuário</h4>
        <hr />
        <Grid container spacing={2} alignItems="center">
            <Grid item md={4} xs={12}>
                <TextField style={{ width: '100%' }} variant="outlined" required label="Nome" value={userInfo.name}
                    error={formErrors.name} onChange={(e) => {
                                                setUserInfo({ ...userInfo, name: e.target.value });
                                                setFormErrors({ ...formErrors, name: false });
                                                }} />
            </Grid>
            <Grid item md={4} xs={12}>
                <TextField style={{ width: '100%' }} variant="outlined" required label="Email" value={userInfo.email}
                    error={formErrors.email} onChange={(e) => {
                                                setUserInfo({ ...userInfo, email: e.target.value });
                                                setFormErrors({ ...formErrors, email: false });
                                                }} />
            </Grid>
            <Grid item md={4} xs={12}>
                <CpfCnpj label="Documento" required value={userInfo.document}
                    error={formErrors.document} onChange={(e) => {
                                                setUserInfo({ ...userInfo, document: e.target.value });
                                                setFormErrors({ ...formErrors, document: false });
                                                }} />
            </Grid>
            <Grid item md={4} xs={12}>
                <FormControl style={{ width: '100%' }} required error={formErrors.type}>
                    <InputLabel className="select-label" shrink>Perfil</InputLabel>
                    <Select native label="Perfil" variant="outlined" value={userInfo.type}
                        onChange={(e) => {
                                        setUserInfo({ ...userInfo, type: e.target.value });
                                        setFormErrors({ ...formErrors, type: false });
                                        }}>
                    <option value={"ARTIST"}>Titular</option>
                    <option value={"CLIENT"}>Cliente(Selo/Editora)</option>
                    <option value={"AGENT"}>Agente</option>
                    <option value={"ORBTEAM"}>ORB Team</option>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item md={4} xs={12}>
                {userInfo.type === "ARTIST" ?
                    <SuggestContributors margin={false} useToFilter={true} error={formErrors.contributor}
                        value={userInfo.contributor_name}
                        onChange={(contributor) => {
                                            setUserInfo({ ...userInfo, contributor_name: contributor.name, contributor_id: contributor.id });
                                            setFormErrors({ ...formErrors, contributor: false });
                                        }} />
                : userInfo.type === "CLIENT" ?
                    <ClientsDropDown margin="none" label="Cliente" required error={formErrors.client}
                        value={userInfo.client_id}
                        onChange={(client_id) => {
                                            setUserInfo({ ...userInfo, client_id: client_id });
                                            setFormErrors({ ...formErrors, client: false });
                                        }} />
                : userInfo.type === "AGENT" ?
                    <AgentsDropDown margin="none" label="Agente" required error={formErrors.agent}
                        value={userInfo.agent_id}
                        onChange={(agent_id) => {
                                            setUserInfo({ ...userInfo, agent_id: agent_id });
                                            setFormErrors({ ...formErrors, agent: false });
                                        }} />
                : null
                }
            </Grid>
            <Grid item md={12} xs={12} style={{ textAlign: 'right', marginTop: '135px' }}>
                {isRunning ?
                <Loading size="25px" /> :
                <Button variant="contained" color="secondary" size="large"
                    onClick={updateUser}>Salvar</Button>
                }
            </Grid>
        </Grid>
        </>
    );
};

export default EditUserPanel;
